<div *ngIf="show" class="d-flex justify-content-center" [ngClass]="{'spinner': isFullScreen}">
  <mdb-spinner spinnerColor="red"></mdb-spinner>
</div>